interface Purchase {
  merchant: string;
  amount: number;
  date: string;
}

export const getTopPurchases = (transactions: any[]): Purchase[] => {
  // Filter out transfers and get top 5 purchases by amount
  return transactions
    .filter(t => {
      // Filter out positive amounts (income/transfers in)
      if (t.amount >= 0) return false;
      
      // Use merchant_name if available, fallback to description
      const description = (t.merchant_name || t.description || '').toLowerCase();
      
      // Filter out transfers and financial transactions
      const transferKeywords = [
        'transfer', 'zelle', 'venmo', 'paypal', 'chase', 'bank', 
        'deposit', 'withdrawal', 'wise', 'revolut', 'exchange',
        'forex', 'currency', 'remit', 'wire', 'to:', 'payment to',
        'paid to', 'sent to'
      ];
      
      // Check if it's a transfer or financial transaction
      if (transferKeywords.some(keyword => description.includes(keyword))) {
        return false;
      }
      
      // Check if it starts with "to" followed by a space (likely a payment to someone)
      if (description.match(/^to\s/i)) {
        return false;
      }
      
      // Check for common name patterns (e.g., "John Smith", "JANE DOE")
      if (description.match(/^[A-Z][a-z]+\s+[A-Z][a-z]+$/)) {
        return false;
      }
      
      return true;
    })
    .sort((a, b) => Math.abs(b.amount) - Math.abs(a.amount))
    .slice(0, 5)
    .map(t => ({
      merchant: t.merchant_name || t.description || 'Unknown Merchant',
      amount: Math.abs(t.amount),
      date: t.date
    }));
};
